import { atom } from 'jotai'

import { TotalViewsTimescale } from '../../../types'
import { DEFAULT_TIMESCALE } from './constants'

export const timescaleAtom = atom<TotalViewsTimescale>(DEFAULT_TIMESCALE)
